import React from 'react';
import './App.css';
import 'leaflet/dist/leaflet.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import AppLayout from './components/app/AppLayout';
import Dashboard from './pages/Dashboard';
import Prospeccion from './pages/Prospeccion';
import Prospecciones from './pages/Prospecciones';
import Negociaciones from './pages/Negociaciones';
import Capitalizaciones from './pages/Capitalizaciones';
import Normativa from './pages/Normativa';
import Admin from './pages/Admin';
import Ofrecimientos from './pages/Ofrecimientos';
import MantenimientoDashboard from './pages/MantenimientoDashboard';
import Incidencias from './pages/Incidencias';
import TotemDashboard from './pages/TotemDashboard';
import Emplazamientos from './pages/Emplazamientos';
import HeatMapNacional from './pages/HeatMapNacional';
import Preventivo from './pages/Preventivo';
import Conflictivos from './pages/Conflictivos';
import Agenda from './pages/Agenda';
import Eventos from './pages/Eventos';
import Ranking from './pages/Ranking';
import Fichaje from './pages/Fichaje';
import FichajesMapa from './pages/FichajesMapa';
import PartesAdmin from './pages/PartesAdmin';
import GastosElectricos from './pages/GastosElectricos';
import Ayuda from './pages/Ayuda';
import Facturacion from './pages/Facturacion';
import PushLog from './pages/PushLog';
import DashboardAdmin from './pages/DashboardAdmin';
import BajadaRenta from './pages/BajadaRenta';
import Mensajes from './pages/Mensajes';
import Pitch from './pages/Pitch';
import { Loader2 } from 'lucide-react';

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center">
        <Loader2 className="animate-spin text-[#A3FF12]" size={36}/>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/app" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/pitch" element={<Pitch />} />
            <Route path="/app" element={<Protected><AppLayout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="prospeccion" element={<Prospeccion />} />
              <Route path="prospecciones" element={<Prospecciones />} />
              <Route path="negociaciones" element={<Negociaciones />} />
              <Route path="ofrecimientos" element={<Ofrecimientos />} />
              <Route path="capitalizaciones" element={<Capitalizaciones />} />
              <Route path="mantenimiento" element={<MantenimientoDashboard />} />
              <Route path="incidencias" element={<Incidencias />} />
              <Route path="totem-dashboard" element={<TotemDashboard />} />
              <Route path="emplazamientos" element={<Emplazamientos />} />
              <Route path="heatmap" element={<HeatMapNacional />} />
              <Route path="preventivo" element={<Preventivo />} />
              <Route path="conflictivos" element={<Conflictivos />} />
              <Route path="bajada-renta" element={<BajadaRenta />} />
              <Route path="agenda" element={<Agenda />} />
              <Route path="eventos" element={<Eventos />} />
              <Route path="ranking" element={<Ranking />} />
              <Route path="fichaje" element={<Fichaje />} />
              <Route path="fichajes-mapa" element={<FichajesMapa />} />
              <Route path="partes" element={<AdminOnly><PartesAdmin /></AdminOnly>} />
              <Route path="gastos-electricos" element={<GastosElectricos />} />
              <Route path="normativa" element={<Normativa />} />
              <Route path="facturacion" element={<Facturacion />} />
              <Route path="ayuda" element={<Ayuda />} />
              <Route path="mensajes" element={<Mensajes />} />
              <Route path="push-log" element={<AdminOnly><PushLog /></AdminOnly>} />
              <Route path="dashboard-admin" element={<AdminOnly><DashboardAdmin /></AdminOnly>} />
              <Route path="admin" element={<AdminOnly><Admin /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/app" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
